<ng-container *ngIf="multi; else simpleDropDownList">
  <kendo-multiselect
    [data]="data"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
    (valueChange)="onChange($event)"
  ></kendo-multiselect>
</ng-container>

<ng-template #simpleDropDownList>
  <kendo-dropdownlist
    [data]="data"
    [value]="selectedValue"
    [valuePrimitive]="true"
    [textField]="textField"
    [valueField]="valueField"
    (valueChange)="onChange($event)"
  >
  </kendo-dropdownlist>
</ng-template>
